import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CurrencyInput as CleanCurrencyInput } from '../../components';
import { Props as CleanCurrencyInputProps } from '../../components/CurrencyInput/CurrencyInput';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

interface Transform {
  input: (value: any) => any;
  output: (value: any) => any;
}

interface Props extends CleanCurrencyInputProps {
  transform?: Transform;
}

const pattern = new RegExp(/[()\-,_ %£]+|(years)+/, 'g');

export const transformCurrencyToNumber = {
  input: (value: any) => {
    return value;
  },
  output: (value: any) => {
    const replace = value.replace(pattern, '');

    return replace ? Number(replace) : null;
  },
};

const DecimalCurrencyInput: React.FC<Props> = ({
  name,
  state,
  transform = transformCurrencyToNumber,
  onBlur,
  ...props
}) => {
  const { control } = useFormContext<any>();

  const input = (value: any) => {
    return transform && transform.input ? transform.input(value) : value;
  };

  const output = (value: any) => {
    return transform && transform.output ? transform.output(value) : value;
  };

  if (name === undefined) {
    throw new Error('Name can not be undefined');
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CleanCurrencyInput
          {...field}
          {...props}
          mask={createNumberMask({
            prefix: '',
            allowNegative: true,
            allowDecimal: true,
          })}
          state={state}
          value={input(field.value)}
          onChange={(e) => {
            field.onChange(output(e.target.value));
            field.onBlur();
          }}
          onBlur={(e) => {
            field.onBlur();

            if (typeof onBlur === 'function') {
              const event: typeof e = {
                ...e,
                target: {
                  ...e.target,
                  value: output(e.target.value),
                },
              };
              onBlur(event);
            }
          }}
        />
      )}
    />
  );
};

export default DecimalCurrencyInput;
